import { cardAnatomy } from '@chakra-ui/react/anatomy';
import { defineSlotRecipe } from '@chakra-ui/react/styled-system';

const cardSlotRecipe = defineSlotRecipe({
  className: 'card',
  slots: cardAnatomy.keys(),
  base: {
    root: {
      backgroundColor: 'background/primary',
      border: '1px solid',
      borderRadius: '8',
      // A card rendered as an inline element -- a link, via `asChild` -- would otherwise draw its
      // border in fragments around its block children instead of as one box.
      display: 'block',
    },
    footer: {
      borderTop: '1px solid',
      borderTopColor: 'border/minimal',
    },
  },
  variants: {
    elevation: {
      true: {
        root: {
          borderColor: 'border/minimal',
          boxShadow: 'elevation/sm',
        },
      },
      false: {
        root: {
          borderColor: 'border/regular',
        },
      },
    },
    /**
     * For a card that is itself the target -- a link or a button, like a list of apps or projects. It
     * answers hover with a tinted background and a stronger border; the elevation stays as it is.
     * Render the card as that element (`asChild`, or a `LinkOverlay` inside), so the hover belongs to
     * something you can actually activate.
     */
    interactive: {
      true: {
        root: {
          _hover: {
            backgroundColor: 'background/secondary',
            borderColor: 'border/hover',
          },
        },
      },
      false: {},
    },
    paddingSize: {
      sm: {
        body: {
          padding: '16',
        },
        footer: {
          paddingInline: '16',
          paddingBlock: '8',
        },
      },
      md: {
        body: {
          paddingInline: '24',
          paddingBlock: '16',
        },
        footer: {
          paddingInline: '24',
          paddingBlock: '8',
        },
      },
      lg: {
        body: {
          padding: '24',
        },
        footer: {
          paddingInline: '24',
          paddingBlock: '12',
        },
      },
    },
  },
  defaultVariants: {
    elevation: true,
    interactive: false,
    paddingSize: 'lg',
  },
});

export default cardSlotRecipe;
